import { Typography } from "@/components/shared/typography";
import { Button, Skeleton, View } from "@/components/ui";
import { TopUpCreditCard } from "./TopUpCreditCard";
import type { CreditPackageData } from "@/types/profile";
import { LoadingDialog } from "@/components/shared/loading-dialog";
import { useState } from "react";
import { Divider } from "@/components/shared/divider";
import { showToast } from "@/components/ui/toast/show-toast";

export const TopUpCreditCardList = ({
  creditPackages,
  handleClick,
  packageDetailsLoading,
  topUpLoading,
}: {
  creditPackages: CreditPackageData[];
  handleClick(id: string): void;
  packageDetailsLoading: boolean;
  topUpLoading: boolean;
}) => {
  const [selectedPackageId, setSelectedPackageId] = useState<string | null>(
    null,
  );

  const handleContinue = () => {
    if (!selectedPackageId) {
      showToast({
        type: "error",
        title: "Please select a package",
      });
      return;
    }

    handleClick(selectedPackageId);
  };

  return (
    <>
      {topUpLoading ? (
        <LoadingDialog open={topUpLoading} />
      ) : (
        <View className="p-4 web:p-2">
          <Typography variant="label-md" color="foreground-default">
            Buy Credits
          </Typography>
          <Typography variant="body-sm" color="foreground-intermediate">
            Choose a massage credit package and get extra value
          </Typography>
          <Divider className="mt-6 hidden web:block" />
          <View className="flex flex-col gap-4 py-4">
            {packageDetailsLoading ? (
              <Skeleton />
            ) : (
              creditPackages.map((pkg, index) => {
                return (
                  <TopUpCreditCard
                    key={pkg.id}
                    price={pkg.price}
                    description={pkg.description ?? ""}
                    baseAmount={pkg.amount ?? 0}
                    bonusAmount={pkg.bonusAmount ?? 0}
                    isBestPick={index === 0}
                    expirationInMonth={pkg.expirationInMonth ?? 0}
                    isSelected={selectedPackageId === pkg.id}
                    handleClick={() => {
                      setSelectedPackageId(pkg.id);
                    }}
                  />
                );
              })
            )}
          </View>
          <View className="flex flex-col">
            <Button
              size="lg"
              variant="primary"
              color="CTA"
              onClick={handleContinue}
            >
              Continue
            </Button>
            <Typography
              variant="body-sm"
              color="foreground-intermediate"
              className="my-2"
              align="center"
            >
              By clicking Continue, an invoice will be generated and will expire
              in 24 hours.
            </Typography>
          </View>
        </View>
      )}
    </>
  );
};
